export const glossaryData = [
  {
    label: "A",
    content: [
      {
        title: "Active Treatment",
        definition:
          "The stage of orthodontic treatment is when teeth are being moved and/or jaws aligned.",
      },
      {
        title: "Advanced periodontitis",
        definition:
          "The most severe form of gum (periodontal) disease. It is a chronic infection of the gums caused by accumulation of plaque under the gum line. The plaque contains bacteria that produce toxins that destroy the soft tissue and bone that hold teeth in place. Pockets (spaces between the gum and the teeth) appear and deepen. Gums recede, and bone dissolves. Teeth can become loose and may have to be removed.",
      },
      {
        title: "Aligners",
        definition:
          "Clear, thin, removable trays that are formed to fit an individual’s teeth and are used to straighten teeth. Patients are responsible for insertion and removal.",
      },
      {
        title: "American Association of Orthodontists (AAO)",
        definition:
          "The AAO is a professional association of educationally qualified orthodontic specialists who create healthy, beautiful smiles for their patients. The AAO only admits orthodontists as members. Orthodontists first graduate from dental school and then complete an additional two to three years of education in the orthodontic specialty at accredited orthodontic residency programs. Selecting an AAO member for orthodontic care is your assurance that the doctor is an orthodontist.",
      },
      {
        title: "Anterior",
        definition: "Front.",
      },
      {
        title: "Appliances",
        definition:
          "Any device used by an orthodontist, attached to the teeth or removable, designed to move the teeth, change the position of the jaw, or hold the teeth.",
      },
      {
        title: "Arch",
        definition: "Upper or lower jaw. The 'dental arch.'",
      },
      {
        title: "Archwire",
        definition:
          "The metal wire that is attached to the braces and used to move the teeth.",
      },
      {
        title: "Attachments",
        definition:
          "The tooth-colored 'bumps' are placed on teeth during clear aligner treatment. They help move the teeth while a patient wears aligners. They are removed once treatment is complete.",
      },
    ],
  },
  {
    label: "B",
    content: [
      {
        title: "Band",
        definition:
          "A metal ring, usually on a back tooth, that is cemented to a tooth for strength and anchorage.",
      },
      {
        title: "Bite",
        definition:
          "How top and bottom teeth come together. Ideally, each tooth meets its opposite tooth in a way that promotes functions such as biting, chewing and speaking. A bad bite is called a malocclusion. The goal of orthodontic treatment is to create an individualized healthy bite.",
      },
      {
        title: "Blue Grass Appliance",
        definition:
          "Used to help in the correction of a tongue thrust. Helps the patient retrain the tongue when swallowing, and can help correct an open bite.",
      },
      {
        title: "Board-Certified Orthodontist",
        definition:
          "An orthodontist who has completed the American Board of Orthodontics Specialty Certification exams. A board-certified orthodontist is known as a Diplomate of the American Board of Orthodontics.",
      },
      {
        title: "Braces",
        definition:
          "A word commonly used to describe a fixed orthodontic appliance, usually consisting of brackets, bands, and wires.",
      },
      {
        title: "Bracket",
        definition:
          "The small metal, ceramic, or plastic attachment bonded to each tooth with a tooth-colored adhesive.",
      },
      {
        title: "Bridge",
        definition:
          "A replacement for a missing natural tooth/teeth that fills the opening between adjacent teeth.",
      },
      {
        title: "Brushing",
        definition:
          "Brushing the teeth is part of an individual’s daily home dental care. Patients with braces should follow the orthodontist’s instruction on how often to brush.",
      },
      {
        title: "Bruxism",
        definition:
          "Grinding of the teeth, usually during sleep. Bruxism can cause abnormal tooth wear and may lead to pain in the jaw joints.",
      },
      {
        title: "Buccal",
        definition:
          "A term orthodontists use to describe the cheek side of the back teeth in both jaws.",
      },
      {
        title: "Buccal Tube",
        definition:
          "A small metal part of the bracket welded to the cheek side of the molar band.",
      },
    ],
  },
  {
    label: "C",
    content: [
      {
        title: "Cephalometric Radiograph",
        definition: "A side view x-ray of the head.",
      },
      {
        title: "Chain",
        definition:
          "A stretchable series of elastic o-rings connected together and placed around each bracket to hold the archwire in place.",
      },
      {
        title: "Class I Malocclusion",
        definition:
          "A malocclusion in which the back molars meet properly, but the front teeth may appear to be crowded together or spaced apart.",
      },
      {
        title: "Class II Malocclusion",
        definition:
          "A malocclusion where the lower teeth and/or jaw is positioned back relative to the upper teeth and/or jaw.",
      },
      {
        title: "Class III Malocclusion",
        definition:
          "A malocclusion where the lower teeth and/or jaw is positioned ahead relative to the upper teeth and/or jaw.",
      },
      {
        title: "Closed Bite/Deep Bite",
        definition:
          "Occurs when the upper front teeth overlap the bottom front teeth an excessive amount.",
      },
      {
        title: "Comprehensive Treatment",
        definition:
          "Complete orthodontic treatment performed to correct a malocclusion.",
      },
      {
        title: "Cone Beam CT/CBCT",
        definition: "A 3D x-ray.",
      },
      {
        title: "Congenitally Missing Teeth",
        definition:
          "A genetic occurrence in which permanent teeth do not develop.",
      },
      {
        title: "Crossbite",
        definition:
          "Upper back teeth are in crossbite if they erupt and contact inside or outside of the lower back teeth.",
      },
      {
        title: "Crown",
        definition:
          "The part of the tooth that is visible above the gums; OR, a tooth restoration placed by a dentist.",
      },
    ],
  },
  {
    label: "D",
    content: [
      {
        title: "DDS or DMD",
        definition:
          "DDS (Doctor of Dental Surgery) and DMD (Doctor of Dental Medicine) are degrees awarded to dental school graduates.",
      },
      {
        title: "Decalcification",
        definition:
          "White marks on the teeth that can become cavities in the future.",
      },
      {
        title: "Dentist",
        definition:
          "Practicing general dentists are healthcare professionals concerned with overall oral health.",
      },
      {
        title: "Diagnostic Records",
        definition:
          "The materials and information that the orthodontist needs to properly diagnose a malocclusion and plan a patient’s treatment.",
      },
    ],
  },
  {
    label: "E",
    content: [
      {
        title: "Ectopic Eruption",
        definition:
          "Term used to describe a tooth or teeth that erupt in an abnormal position.",
      },
      {
        title: "Elastics",
        definition:
          "Rubber bands worn during certain stages of treatment to provide individual tooth movement or jaw alignment.",
      },
      {
        title: "Enamel",
        definition:
          "The hard, white outer layer of a tooth, and the hardest substance in the human body.",
      },
      {
        title: "Eruption",
        definition: "The process by which teeth enter into the mouth.",
      },
      {
        title: "Essix Retainer",
        definition:
          "A removable retainer made of a clear, plastic-like material.",
      },
      {
        title: "Expander",
        definition: "An orthodontic appliance that can widen the jaws.",
      },
      {
        title: "Extraction",
        definition: "The removal of a tooth.",
      },
      {
        title: "Extraoral Photographs",
        definition:
          "Photographs taken of the face from the front and side views.",
      },
    ],
  },
  {
    label: "F",
    content: [
      {
        title: "Facebow",
        definition:
          "An orthodontic appliance worn with orthodontic headgear, used primarily to move the upper first molars back.",
      },
      {
        title: "Fiberotomy",
        definition:
          "A surgical procedure designed to cut part of the gum tissue around teeth.",
      },
      {
        title: "Fixed Appliances",
        definition:
          "An orthodontic appliance that is bonded or cemented to the teeth and cannot be or should not be removed by the patient.",
      },
      {
        title: "Flossing",
        definition:
          "An important part of daily home dental care, removing plaque and food debris from between the teeth.",
      },
      {
        title: "Forsus Spring",
        definition:
          "An orthodontic appliance made of a fixed spring mechanism that moves the lower jaw forward.",
      },
      {
        title: "Frenum",
        definition:
          "The tissue attachment between the lip and the tongue or the lip and the upper jaw.",
      },
      {
        title: "Frenectomy",
        definition: "The surgical removal or repositioning of the frenum.",
      },
      {
        title: "Function",
        definition: "Refers to biting, chewing and speaking.",
      },
      {
        title: "Functional Appliances",
        definition:
          "A type of orthodontic appliance that uses jaw movement and muscle action to place selective force on the teeth and jaws.",
      },
    ],
  },
  {
    label: "G",
    content: [
      {
        title: "Gingiva",
        definition: "Soft tissue around the teeth, also known as the gums.",
      },
      {
        title: "Gingivitis",
        definition:
          "The mildest type of gum (periodontal) disease, usually caused by poor dental hygiene.",
      },
      {
        title: "Growth Modification",
        definition:
          "Placing braces or appliances to help modify and correct the growth of the jaws and teeth.",
      },
      {
        title: "Gum disease",
        definition:
          "Chronic infection of the gums that stems from a build-up of plaque.",
      },
      {
        title: "Gummy Smile",
        definition:
          "Showing an excessive amount of gingival tissue above the front teeth when smiling.",
      },
    ],
  },
  {
    label: "H",
    content: [
      {
        title: "Hawley Retainer",
        definition:
          "A removable retainer made of wire and a hard plastic-like material.",
      },
      {
        title: "Headgear",
        definition:
          "An appliance worn outside of the mouth to provide traction for growth modification and tooth movement.",
      },
      {
        title: "Herbst Appliance",
        definition:
          "This appliance is used to move the lower jaw forward. It can be fixed or removable. When it is fixed, it is cemented to teeth in one or both arches using stainless steel crowns. An expansion screw may be used to widen the upper jaw at the same time.",
      },
      {
        title: "Holding/Lingual Arch",
        definition:
          "Bands on the upper or lower molars are connected using a bar behind teeth; used to maintain space.",
      },
    ],
  },
  {
    label: "I",
    content: [
      {
        title: "Impaction",
        definition:
          "A tooth that does not erupt into the mouth or only erupts partially is considered impacted.",
      },
      {
        title: "Implant",
        definition:
          "An artificial replacement for a missing tooth/teeth. The process involves placing a metal post in the jawbone. A crown is placed on the implant so that the patient is able to bite, chew and speak. Implants can be used to anchor a single tooth or multiple teeth. An orthodontist can create space or hold space open in the mouths of patients who may need implants to achieve good dental function. Dental implants cannot be moved by conventional orthodontic forces.",
      },
      {
        title: "Interceptive Treatment",
        definition:
          "Orthodontic treatment is performed to intercept or correct a developing problem. Usually performed on younger patients that have a mixture of primary (baby) teeth and permanent teeth. Sometimes called Preventive or Phase I treatment.",
      },
      {
        title: "Intraoral Photographs",
        definition:
          "Photographs taken of the inside of the mouth, usually showing the biting surfaces of the teeth and sides of the mouth while biting down.",
      },
      {
        title: "Interproximal Brush",
        definition:
          "A tiny brush used to reach between teeth, and between teeth and braces, to remove plaque and food debris.",
      },
      {
        title: "Interproximal Reduction",
        definition:
          "Removal of a small amount of enamel from between the teeth to reduce their width. Also known as reproximation, slenderizing, stripping, polishing, enamel reduction or selective reduction.",
      },
    ],
  },
  {
    label: "L",
    content: [
      {
        title: "Labial",
        definition:
          "The surface of the teeth in both jaws that faces the lips.",
      },
      {
        title: "Ligating Modules",
        definition:
          "A small elastic o-ring, shaped like a donut, used to hold the archwire in the bracket. Also called 'o-rings' or 'o-ties.'",
      },
      {
        title: "Ligature",
        definition:
          "A tiny rubber band, or sometimes a very thin wire, that holds the orthodontic wire in the bracket slot/brace.",
      },
      {
        title: "Lingual",
        definition: "The tongue side of the teeth in both jaws.",
      },
      {
        title: "Lip Bumper",
        definition:
          "An orthodontic appliance used to move the lower molars back and the lower front teeth forward, creating room for crowded front teeth. The lower lip muscles apply pressure to the bumper creating a force that moves the molars back.",
      },
      {
        title: "Lip Incompetence",
        definition:
          "The inability to close the lips together at rest, usually due to protrusive front teeth or an excessively long face.",
      },
    ],
  },
  {
    label: "M",
    content: [
      {
        title: "Malocclusion",
        definition:
          "Latin for 'bad bite.' The term used in orthodontics to describe teeth that do not fit together properly.",
      },
      {
        title: "Mandible",
        definition: "The lower jaw.",
      },
      {
        title: "MARA Appliance",
        definition:
          "A type of functional appliance used to bring the lower jaw forward to correct an overjet.",
      },
      {
        title: "Maxilla",
        definition: "The upper jaw.",
      },
      {
        title: "Mixed Dentition",
        definition:
          "The dental developmental stage in children (approximately ages 6-12) when they have a mix of primary (baby) and permanent teeth.",
      },
      {
        title: "Mouthguard",
        definition:
          "A removable device used to protect the teeth and mouth from injury caused by sporting activities. The use of a mouthguard is especially important for orthodontic patients.",
      },
    ],
  },
  {
    label: "N",
    content: [
      {
        title: "Nightguard",
        definition:
          "A removable appliance worn at night to help an individual minimize the damage or wear that occurs while clenching or grinding teeth during sleep.",
      },
    ],
  },
  {
    label: "O",
    content: [
      {
        title: "Occlusion",
        definition:
          "Latin for 'bite.' In orthodontics, occlusion describes how the upper and lower teeth meet.",
      },
      {
        title: "Open Bite",
        definition:
          "A malocclusion in which teeth do not make contact with each other. With an anterior open bite, the front teeth do not touch when the back teeth are closed together. With a posterior open bite, the back teeth do not touch when the front teeth are closed together.",
      },
      {
        title: "O-ring",
        definition:
          "A tiny, o-shaped rubber band that is used as a ligature and holds the archwire to bracket slots. O-rings come in a variety of colors, and are generally changed at each adjustment appointment.",
      },
      {
        title: "Orthodontics",
        definition:
          "The specialty area of dentistry concerned with the diagnosis, supervision, guidance and correction of malocclusions. The formal name of the specialty is orthodontics and dentofacial orthopedics.",
      },
      {
        title: "Orthodontist",
        definition:
          "A specialist in the diagnosis, prevention and treatment of dental and facial irregularities. Orthodontists are required to complete college requirements, graduate from an accredited dental school and then successfully complete a minimum of two years of full-time study at an accredited orthodontic residency program. Only those who have completed this education may call themselves 'orthodontists.' Orthodontists limit their scope of practice to orthodontic treatment. Only orthodontists may be members of the American Association of Orthodontists (AAO).",
      },
      {
        title: "Orthognathic surgery",
        definition:
          "Also called surgical orthodontics, orthognathic surgery is corrective jaw surgery performed to remedy skeletal problems that affect the ability to bite, chew and speak. Orthodontic treatment is done before and after surgery so that upper and lower teeth meet appropriately.",
      },
      {
        title: "Orthopedic Appliance",
        definition:
          "A removable functional appliance designed to guide the growth of the jaws and face.",
      },
      {
        title: "Overbite",
        definition:
          "The upper front teeth excessively overlap the bottom front teeth when back teeth are closed. Also called a closed bite or deep bite.",
      },
      {
        title: "Overjet",
        definition:
          "The upper front teeth protrude in front of the bottom front teeth when back teeth are closed. Sometimes called buck teeth.",
      },
    ],
  },
  {
    label: "P",
    content: [
      {
        title: "Panoramic Radiograph",
        definition: "An x-ray that shows all the teeth and both jaws at once.",
      },
      {
        title: "Palatal Expander",
        definition:
          "A fixed or removable orthodontic appliance used to make the upper jaw wider.",
      },
      {
        title: "Periodontal Disease",
        definition:
          "A chronic infection of the gums and jaw bones that stems from a build-up of plaque; many times there is little or no pain. Untreated periodontal disease can lead to tooth loss. There are three stages of periodontal disease: gingivitis, periodontitis and advanced periodontitis.",
      },
      {
        title: "Periodontal Tissue",
        definition:
          "Refers to the hard and soft tissue, or supporting structures, around the teeth.",
      },
      {
        title: "Periodontitis",
        definition:
          "A more serious form of gum (periodontal) disease as compared to gingivitis. It is a chronic infection caused by an accumulation of plaque under the gum line. The bacteria in plaque produce toxins that lead to destruction of the soft tissue and bone that hold teeth in place. Pockets (spaces between the gum and the teeth) form. Unless treated professionally in conjunction with careful home care, the disease process will continue to break down tissues.",
      },
      {
        title: "Phase One (Phase I) Treatment",
        definition:
          "Orthodontic treatment performed to intercept or correct a developing problem. Usually performed on younger patients that have a mixture of primary (baby) teeth and permanent teeth. Sometimes called Preventive or Interceptive treatment.",
      },
      {
        title: "Plaque",
        definition:
          "Plaque is a colorless, sticky film which is a mixture of bacteria, food particles and saliva that constantly forms in the mouth. Plaque combines with sugars to form an acid that endangers teeth and gums. Plaque causes cavities, white marks (decalcification) and gum disease. Plaque is removed by brushing and flossing.",
      },
      {
        title: "Posterior",
        definition: "Back.",
      },
      {
        title: "Power chain",
        definition:
          "Interconnected elastic ligatures that are stretched across multiple teeth, holding the archwire to bracket slots. Orthodontists use power chains for some patients during specific times during their treatment to apply additional forces to move teeth.",
      },
      {
        title: "Preventive Treatment",
        definition:
          "Orthodontic treatment to prevent or reduce the severity of a developing malocclusion (bad bite). Also called Interceptive or Phase I treatment.",
      },
      {
        title: "Primary Teeth",
        definition: "Baby teeth. Also called deciduous or milk teeth.",
      },
    ],
  },
  {
    label: "R",
    content: [
      {
        title: "Radiograph",
        definition:
          "Also called an x-ray, a radiograph is a diagnostic tool that is used to see inside the body. Orthodontists take panoramic radiographs to see a complete horizontal image of a patient’s upper and lower teeth. A cephalometric radiograph is a side view of a patient’s head.",
      },
      {
        title: "Removable Appliance",
        definition:
          "An orthodontic appliance that can be removed from the mouth by the patient. Removable appliances are used to move teeth, align jaws and/or to keep teeth in their new positions when the braces are removed (retainers).",
      },
      {
        title: "Retainer",
        definition:
          "A fixed or removable appliance worn after braces are removed or aligner therapy is complete. A retainer is fitted to upper and/or lower teeth to hold them in their finished positions. When worn as prescribed, retainers are the best tool available to minimize unwanted tooth movement after active treatment ends.",
      },
      {
        title: "Rubber Bands",
        definition:
          "During certain stages of treatment, small elastics (rubber bands) are worn to provide individual tooth movement or jaw alignment.",
      },
    ],
  },
  {
    label: "S",
    content: [
      {
        title: "Separators",
        definition:
          "An elastic o-ring or small wire loop is placed between the teeth to create space for placement of orthodontic bands. Separators are usually placed between the teeth a week before bands are scheduled to be placed on the teeth.",
      },
      {
        title: "Self-Ligating Brackets",
        definition:
          "Brackets that have a 'door' on the front that holds the orthodontic wire to the bracket. With self-ligating brackets, an elastic ring is not needed to hold the orthodontic wire to the bracket.",
      },
      {
        title: "Serial Extraction",
        definition:
          "Selective or guided removal of certain primary (baby) teeth and/or permanent teeth over a period of time to create room, reduce crowding and create a better environment for the permanent teeth to erupt.",
      },
      {
        title: "Skeletal maturity",
        definition:
          "A time when an individual has stopped growing, and bones have reached their full development.",
      },
      {
        title: "Spacers",
        definition:
          "Tiny elastics (rubber bands) that are inserted between molars. Spacers are placed one or two weeks before getting braces to create space between molars if molar bands will be used as part of the orthodontic appliance. Occasionally, spacers fall out before braces are placed.",
      },
      {
        title: "Space Maintainer",
        definition:
          "A fixed appliance used to hold space for an unerupted permanent tooth after a primary (baby) tooth has been lost prematurely, due to accident or decay.",
      },
      {
        title: "Specialist",
        definition:
          "In dentistry, being a specialist usually requires: General education – Completing college requirements (usually four years); Dental School Education: Four-year program leading to a DDS or DMD in dentistry; Specialty education – Successful completion of two or more years (usually) of additional education in an accredited program in the chosen specialty area (such orthodontics in dentistry). Thus the doctor’s experience is focused on the area of specialization. Orthodontists are the dental profession’s specialists in the field of orthodontics and dentofacial orthopedics. Nine dental specialties are recognized by the National Commission on Recognition of Dental Specialties and Certifying Boards.",
      },
      {
        title: "Supernumerary Teeth",
        definition:
          "An occurrence in which there are more teeth than the usual number. These teeth can be malformed or erupt abnormally. These teeth can also interfere with the normal pattern of tooth eruption and contribute to an orthodontic problem. Supernumerary teeth often need to be removed.",
      },
    ],
  },
  {
    label: "T",
    content: [
      {
        title: "Temporary Anchorage Device (TAD)",
        definition:
          "A miniature surgical screw that resembles an earring stud when it is in place. Positioned in gum and bone tissue, a TAD is used as an anchor – a fixed point from which to apply the force needed to move teeth in a direction that braces alone cannot move them. The TAD is removed when it is no longer needed.",
      },
      {
        title: "Tongue Crib",
        definition:
          "A fixed orthodontic appliance used to help a patient stop habits or undesirable tongue forces exerted on the teeth and bone that supports the teeth.",
      },
      {
        title: "Tongue Thrust",
        definition:
          "A habit where an individual’s tongue pushes against the teeth when swallowing. This type of force generated by the tongue can move the teeth and bone and may lead to an anterior or posterior open bite.",
      },
    ],
  },
  {
    label: "U",
    content: [
      {
        title: "Underbite",
        definition:
          "The lower front teeth or jaw sit ahead of the upper front teeth or jaw. Also known as a Class III malocclusion.",
      },
    ],
  },
  {
    label: "V",
    content: [
      {
        title: "Veneer",
        definition:
          "A thin, tooth-colored shell that is glued to the fronts of teeth to improve their appearance. A veneer can cover up a discolored or broken tooth. Veneers cannot correct malocclusions (misaligned teeth and/or jaws). However, veneers can be easier to place and last longer after an individual has had orthodontic treatment and teeth are properly positioned.",
      },
    ],
  },
  {
    label: "W",
    content: [
      {
        title: "Wax",
        definition:
          "Orthodontic wax is placed on the brackets or archwires to prevent them from irritating the lips or cheeks.",
      },
      {
        title: "Wires",
        definition:
          "Also known as archwires, they are held to brackets using small elastic o-rings (rubber bands), stainless steel wire ligatures, or by a door on a self-ligating bracket. Wires are used to move the teeth.",
      },
    ],
  },
  {
    label: "X",
    content: [
      {
        title: "X-ray",
        definition:
          "Also called a radiograph, an x-ray is a diagnostic tool that is used to see inside the body. Orthodontists take panoramic x-rays to see a complete horizontal image of a patient’s upper and lower teeth. A cephalometric x-ray is a side view of a patient’s head.",
      },
    ],
  },
];
